import { ServicePage } from "../components/ServicePage";

const faq = [
    {
        q: "Wie oft sollte der Rasen gemäht werden?",
        a: "In der Hauptwachstumszeit von Frühjahr bis Herbst ist ein Schnitt pro Woche bis alle vierzehn Tage ideal. Ich biete feste Intervalle an – Sie müssen sich um nichts mehr kümmern und der Rasen bleibt dauerhaft gepflegt.",
    },
    {
        q: "Mein Rasen hat kahle Stellen und Moos. Was hilft?",
        a: "Meist ist eine Kombination aus Vertikutieren und Nachsaat die Lösung: Der Rasen wird gelüftet, Moos und Rasenfilz werden entfernt, kahle Stellen werden vorbereitet und nachgesät. Je nach Witterung zeigt sich das Ergebnis innerhalb weniger Wochen – ein dichter Rasen braucht etwas Geduld, aber er kommt.",
    },
    {
        q: "Arbeiten Sie auch einmalig oder nur regelmäßig?",
        a: "Beides. Ob einmaliger Rasenschnitt vor einem Fest, die Reparatur einer Problemfläche oder die regelmäßige Pflege über die ganze Saison – Sie entscheiden, was Sie brauchen.",
    },
    {
        q: "Was kostet Rasenpflege in Celle?",
        a: "Der Preis richtet sich nach Fläche, Zustand und gewünschtem Rhythmus. Nach einer kurzen kostenlosen Besichtigung erhalten Sie ein verbindliches Festpreis-Angebot.",
    },
];

export const Rasenpflege = () => (
    <ServicePage
        eyebrow="Leistung · Landkreis Celle"
        h1="Rasenpflege in Celle – mähen, lüften, reparieren"
        intro="Ein gepflegter Rasen ist das Aushängeschild jedes Grundstücks – und er bleibt nur schön, wenn er regelmäßig gepflegt wird. Ich übernehme im Landkreis Celle das regelmäßige Mähen, die gezielte Pflege und die Reparatur beschädigter oder lückenhafter Rasenflächen."
        image="/leistung-rasenpflege.webp"
        imageAlt="Rasenpflege in Celle – Julian Kosinski mäht eine große Rasenfläche mit dem Aufsitzmäher"
        scope={[
            "Regelmäßiges Mähen im festen Rhythmus",
            "Sauberes Kantenschneiden an Beeten und Wegen",
            "Vertikutieren und Rasenlüften gegen Moos und Filz",
            "Reparatur kahler und lückenhafter Stellen",
            "Nachsaat für ein dichtes Rasenbild",
            "Saisonale Pflege im Frühjahr und Herbst",
        ]}
        sections={[
            {
                title: "Regelmäßige Rasenpflege",
                paragraphs: [
                    "Der wichtigste Faktor für einen dichten, gesunden Rasen ist Konstanz: regelmäßiges Mähen auf die richtige Höhe, sauber geschnittene Kanten an Beeten, Wegen und Zäunen. Ich arbeite mit festen Terminen und Intervallen – Ihr Rasen bleibt gepflegt, ohne dass Sie daran denken müssen.",
                ],
            },
            {
                title: "Rasenreparatur und Nachsaat",
                paragraphs: [
                    "Kahle Stellen, Lücken und moosige Bereiche entstehen durch Staunässe, Schatten, falsches Mähen oder starke Nutzung. Ich bereite beschädigte Flächen vor, locke den Boden auf und säe mit passender Saat nach – bis die Fläche wieder ein geschlossenes, gepflegtes Rasenbild ergibt.",
                    "Ehrlich gesagt: Nachsaat braucht einige Wochen und die richtige Bewässerung. Ich sage Ihnen vorher genau, was Sie erwartet und was Sie selbst dazu beitragen können.",
                ],
            },
            {
                title: "Vertikutieren – wann es sinnvoll ist",
                paragraphs: [
                    "Wächst der Rasen trotz Mähen schwach und verfilzt, liegt meist eine Schicht aus Moos und abgestorbenem Material darüber. Beim Vertikutieren wird diese Schicht herausgearbeitet, der Boden belüftet und der Neuaustrieb angeregt. Der ideale Zeitpunkt ist das Frühjahr – danach kann die Fläche direkt nachgesät werden.",
                ],
            },
        ]}
        faq={faq}
        serviceType="Rasenpflege und Rasenreparatur"
        related={[
            { to: "/heckenschnitt-celle", label: "Heckenschnitt in Celle" },
            { to: "/gartenpflege-celle", label: "Gartenpflege in Celle" },
            { to: "/referenzen", label: "Referenzen ansehen" },
        ]}
    />
);
